import { CopyColumnsType } from "../CopyTableData";
import { EdiTableColumnsType } from "../EdiTable/interface";
import { columnsProps } from "../SuperTable/interface";
import { TABLE_COLUMN_WIDTH } from "../constants/constant";
import { ColumnType } from "antd/lib/table";

/** 商品信息列配置 */
export const goodColumns: columnsProps[] = [
  {
    title: '图片',
    dataIndex: 'skuImageFullUrl',
    width: TABLE_COLUMN_WIDTH.image,
    renderType: 'image',
    fixed: 'left',
  },
  {
    title: 'SKU名称',
    dataIndex: 'skuName',
    ellipsisLine: 2,
    width: TABLE_COLUMN_WIDTH.productName,
  },
  {
    title: 'SKU/自定义SKU',
    dataIndex: ['skuCode', 'customizeSkuCode'],
    renderType: 'copy',
    width: TABLE_COLUMN_WIDTH.customizeSkuCode,
  },
  {
    title: '货号/自定义货号',
    dataIndex: ['productCode', 'customizeProductCode'],
    width: 150,
    renderType: 'copy',
  },
];
/** 商品信息列配置 */
export const productColumns: columnsProps[] = [
  {
    title: '图片',
    dataIndex: 'skuInfo.skuImageFullUrl',
    width: TABLE_COLUMN_WIDTH.image,
    renderType: 'image',
    fixed: 'left',
  },
  {
    title: 'SKU名称',
    dataIndex: 'skuInfo.skuName',
    ellipsisLine: 2,
    width: TABLE_COLUMN_WIDTH.productName,
  },
  {
    title: 'SKU/自定义SKU',
    dataIndex: ['skuInfo.skuCode', 'skuInfo.customizeSkuCode'],
    renderType: 'copy',
    width: TABLE_COLUMN_WIDTH.customizeSkuCode,
  },
  {
    title: '货号/自定义货号',
    dataIndex: ['skuInfo.productCode', 'skuInfo.customizeProductCode'],
    width: 150,
    renderType: 'copy',
  },
];
/** 商品列批次、系列号、期效信息配置 */
export const productAttributeColumns: columnsProps[] = [
  {
    title: '批次号/系列号',
    dataIndex: 'lotOrSerialNumber',
    width: 160,
    renderType: 'copy',
  },
  {
    title: '生效日期',
    dataIndex: 'effectiveDate',
    width: TABLE_COLUMN_WIDTH.date,
  },
  {
    title: '失效日期',
    dataIndex: 'expiryDate',
    width: TABLE_COLUMN_WIDTH.date,
  },
];
/** 可编辑表商品信息列配置 */
export const productEditColumns: EdiTableColumnsType[] = [
  {
    title: '图片',
    dataIndex: 'skuInfo.skuImageFullUrl',
    width: TABLE_COLUMN_WIDTH.image,
    renderType: 'image',
    fixed: 'left',
  },
  {
    title: 'SKU名称',
    dataIndex: 'skuInfo.skuName',
    width: TABLE_COLUMN_WIDTH.productName,
  },
  {
    title: 'SKU/自定义SKU',
    dataIndex: ['skuInfo.skuCode', 'skuInfo.customizeSkuCode'],
    width: TABLE_COLUMN_WIDTH.customizeSkuCode,
  },
  {
    title: '货号/自定义货号',
    dataIndex: ['skuInfo.productCode', 'skuInfo.customizeProductCode'],
    width: 150,
  },
];
/** 可编辑表商品信息列配置 */
export const goodEditColumns: EdiTableColumnsType[] = [
  {
    title: '图片',
    dataIndex: 'skuImageFullUrl',
    width: TABLE_COLUMN_WIDTH.image,
    renderType: 'image',
    fixed: 'left',
  },
  {
    title: 'SKU名称',
    dataIndex: 'skuName',
    width: TABLE_COLUMN_WIDTH.productName,
  },
  {
    title: 'SKU/自定义SKU',
    dataIndex: ['skuCode', 'customizeSkuCode'],
    width: TABLE_COLUMN_WIDTH.customizeSkuCode,
  },
  {
    title: '货号/自定义货号',
    dataIndex: ['productCode', 'customizeProductCode'],
    width: 150,
  },
];

export const addOperationConfig: ColumnType<any> = {
  width: 100,
};

export const skuInfoColumns: columnsProps[] = [
  {
    title: '业务商品编码',
    dataIndex: 'bskuCode',
    formatCopyValue: (_, record) => {
      return record?.bskuMappingSkuInfo?.bskuCode;
    },
  },
  {
    title: '卖家',
    dataIndex: 'merchantName',
    formatCopyValue: (_, record) => {
      return record?.bskuMappingSkuInfo?.merchantName;
    },
  },
  {
    title: 'SKU',
    dataIndex: 'skuCode',
    formatCopyValue: (_, record) => {
      return record?.bskuMappingSkuInfo?.mappingSkuItemList?.[0]?.productSkuInfo?.skuCode;
    },
  },
  {
    title: '自定义SKU',
    dataIndex: 'customizeSkuCode',
    formatCopyValue: (_, record) => {
      return record?.bskuMappingSkuInfo?.mappingSkuItemList?.[0]?.productSkuInfo?.customizeSkuCode;
    },
  },
  {
    title: '货号',
    dataIndex: 'productCode',
    formatCopyValue: (_, record) => {
      return record?.bskuMappingSkuInfo?.mappingSkuItemList?.[0]?.productInfo?.productCode;
    },
  },
  {
    title: '自定义货号',
    dataIndex: 'customizeProductCode',
    formatCopyValue: (_, record) => {
      return record?.bskuMappingSkuInfo?.mappingSkuItemList?.[0]?.productInfo?.customizeProductCode;
    },
  },
];

export const skuInfoCopyColumns: CopyColumnsType[] = [
  {
    title: '业务商品编码',
    name: 'bskuCode',
    formatValue: record => {
      return record?.bskuMappingSkuInfo?.bskuCode;
    },
  },
  {
    title: '卖家',
    name: 'merchantName',
    formatValue: record => {
      return record?.bskuMappingSkuInfo?.merchantName;
    },
  },
  {
    title: 'SKU',
    name: 'skuCode',
    formatValue: record => {
      return record?.bskuMappingSkuInfo?.mappingSkuItemList?.[0]?.productSkuInfo?.skuCode;
    },
  },
  {
    title: '自定义SKU',
    name: 'customizeSkuCode',
    formatValue: record => {
      return record?.bskuMappingSkuInfo?.mappingSkuItemList?.[0]?.productSkuInfo?.customizeSkuCode;
    },
  },
  {
    title: '货号',
    name: 'productCode',
    formatValue: record => {
      return record?.bskuMappingSkuInfo?.mappingSkuItemList?.[0]?.productInfo?.productCode;
    },
  },
  {
    title: '自定义货号',
    name: 'customizeProductCode',
    formatValue: record => {
      return record?.bskuMappingSkuInfo?.mappingSkuItemList?.[0]?.productInfo?.customizeProductCode;
    },
  },
];
